import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import {Divider} from "antd";
const Sclera = props => {
  const {data, isShow = true} = props;
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Củng mạc:</div>}
        {moveElementToEnd(
          Object.keys(data).filter(key => data[key] && key != "show"),
          "Ghi chú"
        ).map(key => {
          return <InfoItem label={"Ghi chú"} value={data[key]}></InfoItem>;
        })}
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="injury">{!checkEmptyObj(data) && render()}</div>;
};
export default Sclera;
